import { Vue, Ref, Prop, Component } from 'vue-property-decorator'

@Component({
})
export default class InteroperabilityModal extends Vue {
    @Ref() readonly interoperabilityModal!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.interoperabilityModal.show()
    }

    hide() {
        this.interoperabilityModal.hide()
    }
}
